import React from "react";
import { Tag } from "antd";
import { messageStatus } from "constant/commonList";

const FilterSection = ({ statusFilter, scheduleType, onFilterChange }) => {
  const desiredStatuses = ["scheduled", "running", "complete", "cancel", "failed"];

  const filterButtons = messageStatus
    .filter(status => {
      // If on "One Time" tab, hide "In Progress" button
      if (scheduleType === "onetime" && status.value === "running") {
        return false;
      }
      return desiredStatuses.includes(status.value);
    })
    .map(status => ({
      label: status.label,
      value: status.value,
      color: status.color
    }));

  return (
    <div className="d-flex align-items-center">
      <span className="text-muted mr-2">Filter by:</span>
      {filterButtons.map(button => (
        <Tag
          key={button.value}
          color={statusFilter === button.value ? button.color : "default"}
          className="mr-2"
          style={{
            cursor: "pointer",
            padding: "5px 12px",
            borderRadius: "15px",
            backgroundColor: statusFilter === button.value ? button.color : "#f0f0f0",
            color: statusFilter === button.value ? "#fff" : "#000",
            border: "1px solid",
            borderColor: statusFilter === button.value ? button.color : "#d9d9d9"
          }}
          onClick={() => onFilterChange(button.value)}
        >
          {button.label}
          {statusFilter === button.value && <i className="fas fa-times ml-2" />}
        </Tag>
      ))}
    </div>
  );
};

export default FilterSection;
